import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';

/**
 * Carta de ventas: RESULTADO → FACILIDAD → PARA QUIÉN → QUÉ APRENDÉS →
 * VARIEDAD → DESEO (rellenos) → OPORTUNIDAD → PRUEBA SOCIAL (maqueta) →
 * BONOS → KIT COMPLETO → PRECIO → GARANTÍA → FAQ → CIERRE.
 *
 * Todo lo que está debajo del primer pantallazo se carga en chunks aparte para
 * que el Hero (LCP en mobile) llegue con el menor JS posible. Cada bloque
 * reserva altura mientras carga, así el CLS queda en cero.
 */
const DesireSection = lazy(() => import('./components/DesireSection').then(m => ({
  default: m.DesireSection
})));
const EasySection = lazy(() => import('./components/EasySection').then(m => ({
  default: m.EasySection
})));
const AudienceSection = lazy(() => import('./components/AudienceSection').then(m => ({
  default: m.AudienceSection
})));
const ContentSection = lazy(() => import('./components/ContentSection').then(m => ({
  default: m.ContentSection
})));
const CatalogSection = lazy(() => import('./components/CatalogSection').then(m => ({
  default: m.CatalogSection
})));
const FlavorsSection = lazy(() => import('./components/FlavorsSection').then(m => ({
  default: m.FlavorsSection
})));
const StuffedSection = lazy(() => import('./components/StuffedSection').then(m => ({
  default: m.StuffedSection
})));
const SellSection = lazy(() => import('./components/SellSection').then(m => ({
  default: m.SellSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const KitBoxSection = lazy(() => import('./components/KitBoxSection').then(m => ({
  default: m.KitBoxSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyBuyBar = lazy(() => import('./components/StickyBuyBar').then(m => ({
  default: m.StickyBuyBar
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-ivory'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="2xtv8qhkdlzfs" />} data-id="element-0" data-mp="2xuddy3p0nnzu">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-ivory text-charcoal" data-id="element-2" data-mp="18drk5y5ejjev">
      {/* RESULTADO */}
      <Hero data-id="element-3" data-mp="18bojmk6mi7vw" />

      <Deferred minHeight="500px" background="bg-ivory" data-id="element-4" data-mp="1d4hmt3mg185v">
        <DesireSection data-id="element-5" data-mp="1d62i4vgl0v4s" />
      </Deferred>

      {/* FACILIDAD */}
      <Deferred minHeight="900px" background="bg-cream" data-id="element-6" data-mp="yg3kctsxvlpu">
        <EasySection data-id="element-7" data-mp="ydikubg45hv9" />
      </Deferred>

      {/* PARA QUIÉN ES */}
      <Deferred minHeight="900px" background="bg-ivory" data-id="element-8" data-mp="13fg9xmb736w4">
        <AudienceSection data-id="element-9" data-mp="1r4ip8nicwnng" />
      </Deferred>

      {/* QUÉ VAS A APRENDER */}
      <Deferred minHeight="1100px" background="bg-cream" data-id="element-10" data-mp="1r2g0s7wur2ku">
        <ContentSection data-id="element-11" data-mp="1w210wlnrdgz5" />
      </Deferred>

      {/* VARIEDAD: el catálogo de 100 */}
      <Deferred minHeight="860px" background="bg-bone" data-id="element-12" data-mp="1i2j5vojvd7hc">
        <CatalogSection data-id="element-13" data-mp="1i5xcj8zkg2ul" />
      </Deferred>

      {/* GALERÍA */}
      <Deferred minHeight="1600px" data-id="element-14" data-mp="1m3l90ggwq3ol">
        <FlavorsSection data-id="element-15" data-mp="6ofcokl3vndc" />
      </Deferred>

      {/* DESEO: el relleno */}
      <Deferred minHeight="900px" background="bg-ivory" data-id="element-16" data-mp="6n4d6wyp11s1">
        <StuffedSection data-id="element-17" data-mp="aq99uiw3e98r" />
      </Deferred>

      {/* OPORTUNIDAD: de la cocina al catálogo */}
      <Deferred minHeight="900px" background="bg-ivory" data-id="element-18" data-mp="qxf7hpbdb1hr">
        <SellSection data-id="element-19" data-mp="qyypplgl3mm6" />
      </Deferred>

      {/* PRUEBA SOCIAL — maqueta con testimonios placeholder */}
      <Deferred minHeight="820px" background="bg-cream" data-id="element-20" data-mp="m4m5vab7499w">
        <TestimonialsSection data-id="element-21" data-mp="h83ys3se7yue" />
      </Deferred>

      {/* LOS 5 BONOS */}
      <Deferred minHeight="1500px" background="bg-bone" data-id="element-22" data-mp="c90voovz42p2">
        <BonosSection data-id="element-23" data-mp="c6enqo567l6b" />
      </Deferred>

      {/* PRECIO */}
      <Deferred minHeight="820px" background="bg-[#E9F0D5]" data-id="element-24" data-mp="19uoufgfwix3r">
        <OfferSection data-id="element-25" data-mp="14x6jxlm8k9tn" />
      </Deferred>

      {/* EL KIT COMPLETO */}
      <Deferred minHeight="1000px" background="bg-ivory" data-id="element-26" data-mp="14v3t4zd9ecnv">
        <TomosSection data-id="element-27" data-mp="zwirqwm9tmxu" />
      </Deferred>

      {/* LA ECUACIÓN DEL KIT */}
      <Deferred minHeight="420px" background="bg-ivory" data-id="element-28" data-mp="vwruca28o8kc">
        <KitBoxSection data-id="element-29" data-mp="vyb9fxc5sdkj" />
      </Deferred>

      {/* GARANTÍA */}
      <Deferred minHeight="360px" background="bg-cream" data-id="element-30" data-mp="3koucl4u7vg6n">
        <GuaranteeSection data-id="element-31" data-mp="3gmpkwbnbwtmn" />
      </Deferred>

      {/* OBJECIONES */}
      <Deferred minHeight="820px" background="bg-ivory" data-id="element-32" data-mp="3gok7rvi5uvtd">
        <FaqSection data-id="element-33" data-mp="1w5gecryhzy4s" />
      </Deferred>

      {/* CIERRE */}
      <Deferred minHeight="900px" data-id="element-34" data-mp="2060abs7c4vpc">
        <FinalCta data-id="element-35" data-mp="2058nb5rt06ao" />
      </Deferred>

      <Deferred minHeight="340px" background="bg-bone" data-id="element-36" data-mp="206a1hj4498wm">
        <Footer data-id="element-37" data-mp="254v23jna5ull" />
      </Deferred>

      <Suspense fallback={null} data-id="element-38" data-mp="253sdxjhce69d">
        <StickyBuyBar data-id="element-39" data-mp="29vtn2wj7rgv6" />
      </Suspense>
    </main>;
}